import { createSlice } from "@reduxjs/toolkit";

// Initial global settings state (fetched from backend)
const initialState = {
  _id: "",
  currency_code: "",
  currency_symbol: "",
  height_unit: "",
  weight_unit: "",
  date_format: "",
  support_email: "",
  support_phone: "",
  app_logo: "",
  app_logo_url: "",
  updated_at: "",
  created_at: "",
};

const globalSettingsSlice = createSlice({
  name: "globalSettings",
  initialState,
  reducers: {
    // Replace entire settings with API payload
    setGlobalSettings: (state, action) => {
      return { ...state, ...action.payload };
    },

    // Merge new values into existing settings
    updateGlobalSettings: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

// Export actions and reducer
export const { setGlobalSettings, updateGlobalSettings } = globalSettingsSlice.actions;
export default globalSettingsSlice.reducer;
